import { RadarGraphComponent } from './radar-graph.component';

export default angular
  .module('sfMobile.components.radarGraph', [])
  .component('sfRadarGraph', RadarGraphComponent).name;
